import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFTextArea from '../../controls/tempRHFControls/RHFTextArea';

interface IScorecardCommentDialogProps {
    dialogName: string;
    scorecardComment: string;
    isDialogVisible: boolean;
    handleComment: (comment: string) => void;
    hideDialog: () => void;
}

const ScorecardCommentDialog = (props: IScorecardCommentDialogProps) => {
    const { register, errors, setValue, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        setValue('comment', props.scorecardComment);
    }, [props.scorecardComment]);

    const onCreate = () => {
        console.log('ScorecardCommentDialog onCreate()');
        setValue('comment', props.scorecardComment);
    };

    useEffect(() => {
        if (props.isDialogVisible) {
            const textarea = document.querySelector('#rhf-textarea') as HTMLTextAreaElement;
            textarea?.focus();
            setValue('comment', props.scorecardComment);
        }
    }, [props.isDialogVisible]);

    const OKClicked = () => {
        props.handleComment(getValues('comment'));
        props.hideDialog();
    };

    return (
        <Dialog title="New Scorecard - Add Comment" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '50%' }}>
            <div>
                <form>
                    <div>
                        <RHFTextArea 
                            name={'comment'}
                            register={register} 
                            errors={errors}
                            style={{width: '100%', height: '20rem'}}
                        />
                    </div>
                    <div className="form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'OK'}
                            onClick={() => OKClicked()}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default ScorecardCommentDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/ScorecardCommentDialog.tsx